// extracted by mini-css-extract-plugin
export default {"summaryPoliciesWrapper":"booking_summary_summaryPoliciesWrapper__fTQs7"};